// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"483ac09c","207":"53d3ec9e","281":"9e074925","358":"ba46727d","512":"ab2b63af","984":"91593c63"}[chunkId] + ".chunk.js";
};